import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { PulseButtonComponent } from '@h20-shared/pulse-components/pulse-button/pulse-button.component';
import type { RowActionButton, RowActionsCellParams } from './row-actions.types';

@Component({
    selector: 'app-row-actions-cell',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FaIconComponent, NgbTooltip, PulseButtonComponent, RouterLink, TranslateModule],
    templateUrl: './row-actions-cell.component.html',
    styleUrl: './row-actions-cell.component.scss',
})
export class RowActionsCellComponent implements ICellRendererAngularComp {
    protected readonly buttons = signal<readonly RowActionButton[]>([]);

    agInit(params: ICellRendererParams & RowActionsCellParams): void {
        this.buttons.set(params.buttons);
    }

    refresh(params: ICellRendererParams & RowActionsCellParams): boolean {
        this.agInit(params);
        return true;
    }
}
